import { CLEAR_DRAFT_EDITOR } from 'modules/editor/store/constants';

export const clearDraftEditor = () => ({
  type: CLEAR_DRAFT_EDITOR,
});
